module.exports = __webpack_public_path__ + "static/media/icon_sentaku1.672dd20e.svg";